<template>
  <p>
    The maximum line of credit amount below will be available while you are pursuing your degree. If
    you don't need the full amount now, it will remain available until you separate from school. If
    you would like to reduce your Line of Credit limit, please reach out to our processing team at
    <a class="email-link" :href="`mailto:${emailAddress}`">{{ emailAddress }}</a
    >.
  </p>
</template>
<script setup lang="ts">
import { useStore } from "vuex";
import useApplicationData from "@/composables/useApplicationData";

useStore();

const { emailAddress } = useApplicationData();
</script>
<style scoped lang="scss">
.email-link {
  color: #007bff;
  text-decoration: underline;
}
</style>
